export const ITEM_ACCESS = {
  MANAGE: 'manage',
  EDIT: 'edit',
  READ: 'read'
}

/**
 * Builds a documentation URL using the configured docs host.
 * @param {string} path - The documentation path (e.g., '/causal-studio/docs/testing/')
 * @returns {string} The full documentation URL
 */
export function getDocsUrl (path) {
  const docsHost = __CONFIG__?.docsHost || 'https://docs.novisci.com'
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const normalizedHost = docsHost.endsWith('/')
    ? docsHost.slice(0, -1)
    : docsHost
  return `${normalizedHost}${normalizedPath}`
}
